export default __webpack_public_path__ + "media/images/mailer-new/heading/appeal-approved-b8a0ed0556fc74c2a2a60fa8a2a47ca3.png";